import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, withModifiers as _withModifiers } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_CustomNumberField = _resolveComponent("CustomNumberField")!
  const _component_VTextFieldFilled = _resolveComponent("VTextFieldFilled")!
  const _component_v_color_picker = _resolveComponent("v-color-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0 ma-0",
    onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "pl-2 my-1"
      }, {
        default: _withCtx(() => [
          (_ctx.divider)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12",
                class: "my-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_divider, { style: {"width":"100%"} })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.title)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "12",
                class: "my-2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasAttr(_ctx.styleObj, 'hidden') && _ctx.isUsed('hidden'))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: _ctx.col,
                class: "px-2 py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: _ctx.styleObj.hidden,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.styleObj.hidden) = $event)),
                    label: "Cacher le bloc",
                    class: "mt-0",
                    disabled: _ctx.disabledHidden
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          (_ctx.hasAttr(_ctx.styleObj, 'boxHeight') && _ctx.isUsed('boxHeight'))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 3,
                cols: _ctx.col,
                class: "px-2 py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomNumberField, {
                    modelValue: _ctx.styleObj.boxHeight,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.styleObj.boxHeight) = $event)),
                    label: "Hauteur de la boite",
                    step: 0.5,
                    min: 0,
                    max: _ctx.internalMaxValues.boxHeight,
                    placeholder: "Auto",
                    disabled: _ctx.internalDisabled,
                    "hide-details": "",
                    "data-cy": "AdvancedBoxEditor-hauteurDeLaBoite"
                  }, {
                    "pre-append": _withCtx(() => _cache[17] || (_cache[17] = [
                      _createElementVNode("div", { style: {"font-size":"small","height":"fit-content","margin":"auto"} }, "mm", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue", "max", "disabled"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          (_ctx.hasAttr(_ctx.styleObj, 'boxWidth') && _ctx.isUsed('boxWidth'))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 4,
                cols: _ctx.col,
                class: "px-2 py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomNumberField, {
                    modelValue: _ctx.styleObj.boxWidth,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.styleObj.boxWidth) = $event)),
                    label: "Largeur de la boite",
                    step: 0.5,
                    min: 0,
                    max: _ctx.internalMaxValues.boxWidth,
                    placeholder: "Auto",
                    disabled: _ctx.internalDisabled,
                    "hide-details": "",
                    "data-cy": "AdvancedBoxEditor-largeurDeLaBoite"
                  }, {
                    "pre-append": _withCtx(() => _cache[18] || (_cache[18] = [
                      _createElementVNode("div", { style: {"font-size":"small","height":"fit-content","margin":"auto"} }, "mm", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue", "max", "disabled"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          (_ctx.hasAttr(_ctx.styleObj, 'padding') && _ctx.isUsed('padding'))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 5,
                cols: _ctx.col,
                class: "px-2 py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomNumberField, {
                    modelValue: _ctx.styleObj.padding,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.styleObj.padding) = $event)),
                    label: "Marges intérieures",
                    step: 0.5,
                    min: 0,
                    max: _ctx.internalMaxValues.padding,
                    placeholder: "Auto",
                    disabled: _ctx.internalDisabled,
                    "hide-details": "",
                    "data-cy": "AdvancedBoxEditor-margesInferieures"
                  }, {
                    "pre-append": _withCtx(() => _cache[19] || (_cache[19] = [
                      _createElementVNode("div", { style: {"font-size":"small","height":"fit-content","margin":"auto"} }, "mm", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue", "max", "disabled"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          (_ctx.hasAttr(_ctx.styleObj, 'leftMargin') && _ctx.isUsed('leftMargin'))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 6,
                cols: _ctx.col,
                class: "px-2 py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomNumberField, {
                    modelValue: _ctx.styleObj.leftMargin,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.styleObj.leftMargin) = $event)),
                    label: "Marge gauche",
                    step: 0.5,
                    max: _ctx.internalMaxValues.leftMargin,
                    placeholder: "Auto",
                    disabled: _ctx.internalDisabled,
                    "hide-details": ""
                  }, {
                    "pre-append": _withCtx(() => _cache[20] || (_cache[20] = [
                      _createElementVNode("div", { style: {"font-size":"small","height":"fit-content","margin":"auto"} }, "mm", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue", "max", "disabled"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          (_ctx.hasAttr(_ctx.styleObj, 'rightMargin') && _ctx.isUsed('rightMargin'))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 7,
                cols: _ctx.col,
                class: "px-2 py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomNumberField, {
                    modelValue: _ctx.styleObj.rightMargin,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.styleObj.rightMargin) = $event)),
                    label: "Marge droite",
                    step: 0.5,
                    max: _ctx.internalMaxValues.rightMargin,
                    placeholder: "Auto",
                    disabled: _ctx.internalDisabled,
                    "hide-details": ""
                  }, {
                    "pre-append": _withCtx(() => _cache[21] || (_cache[21] = [
                      _createElementVNode("div", { style: {"font-size":"small","height":"fit-content","margin":"auto"} }, "mm", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue", "max", "disabled"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          (_ctx.hasAttr(_ctx.styleObj, 'topMargin') && _ctx.isUsed('topMargin'))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 8,
                cols: _ctx.col,
                class: "px-2 py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomNumberField, {
                    modelValue: _ctx.styleObj.topMargin,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.styleObj.topMargin) = $event)),
                    label: "Marge supérieure",
                    step: 0.5,
                    max: _ctx.internalMaxValues.topMargin,
                    placeholder: "Auto",
                    disabled: _ctx.internalDisabled,
                    "hide-details": ""
                  }, {
                    "pre-append": _withCtx(() => _cache[22] || (_cache[22] = [
                      _createElementVNode("div", { style: {"font-size":"small","height":"fit-content","margin":"auto"} }, "mm", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue", "max", "disabled"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          (_ctx.hasAttr(_ctx.styleObj, 'bottomMargin') && _ctx.isUsed('bottomMargin'))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 9,
                cols: _ctx.col,
                class: "px-2 py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomNumberField, {
                    modelValue: _ctx.styleObj.bottomMargin,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.styleObj.bottomMargin) = $event)),
                    label: "Marge inférieure",
                    step: 0.5,
                    max: _ctx.internalMaxValues.bottomMargin,
                    placeholder: "Auto",
                    disabled: _ctx.internalDisabled,
                    "hide-details": ""
                  }, {
                    "pre-append": _withCtx(() => _cache[23] || (_cache[23] = [
                      _createElementVNode("div", { style: {"font-size":"small","height":"fit-content","margin":"auto"} }, "mm", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue", "max", "disabled"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: 12,
            class: "pa-0 ma-0"
          }),
          (_ctx.hasAttr(_ctx.styleObj, 'border') && _ctx.isUsed('border'))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 10,
                cols: _ctx.col,
                class: "px-2 py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: _ctx.styleObj.border,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.styleObj.border) = $event)),
                    color: "primary",
                    label: "Bordures",
                    class: "mt-0",
                    density: "compact",
                    disabled: _ctx.internalDisabled,
                    "data-cy": "AdvancedBoxEditor-bordures"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          (
                    _ctx.hasAttr(_ctx.styleObj, 'borderColor') &&
                    _ctx.hasAttr(_ctx.styleObj, 'border') &&
                    _ctx.isUsed('borderColor')
                )
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 11,
                cols: _ctx.col,
                class: "px-2 py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_menu, {
                    "offset-y": "",
                    "close-on-content-click": false
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_VTextFieldFilled, _mergeProps({
                        modelValue: _ctx.borderColor,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.borderColor) = $event))
                      }, props, {
                        label: "Bordures",
                        readonly: "",
                        "hide-details": "",
                        disabled: !_ctx.styleObj.border || _ctx.disabled,
                        density: "compact"
                      }), {
                        "prepend-inner": _withCtx(() => [
                          _createElementVNode("div", {
                            class: "d-flex align-self-center",
                            style: _normalizeStyle(_ctx.colorIconStyle(_ctx.borderColor))
                          }, null, 4)
                        ]),
                        _: 2
                      }, 1040, ["modelValue", "disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_color_picker, {
                        modelValue: _ctx.borderColor,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.borderColor) = $event)),
                        "show-swatches": "",
                        mode: "hexa",
                        "hide-mode-switch": "",
                        swatches: _ctx.swatches,
                        disabled: _ctx.internalDisabled
                      }, null, 8, ["modelValue", "swatches", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          (_ctx.hasAttr(_ctx.styleObj, 'borderRadius') && _ctx.isUsed('borderRadius'))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 12,
                cols: _ctx.col,
                class: "px-2 py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomNumberField, {
                    modelValue: _ctx.styleObj.borderRadius,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.styleObj.borderRadius) = $event)),
                    label: "Arrondi des bordures",
                    step: 0.5,
                    max: _ctx.internalMaxValues.borderRadius,
                    placeholder: "Auto",
                    disabled: _ctx.internalDisabled,
                    "hide-details": "",
                    "data-cy": "InvoiceThemeMenu-arrondiDesBordures"
                  }, {
                    "pre-append": _withCtx(() => _cache[24] || (_cache[24] = [
                      _createElementVNode("div", { style: {"font-size":"small","height":"fit-content","margin":"auto"} }, "mm", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue", "max", "disabled"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          (_ctx.hasAttr(_ctx.styleObj, 'backgroundColor') && _ctx.isUsed('backgroundColor'))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 13,
                cols: _ctx.col,
                class: "px-2 py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_menu, {
                    "offset-y": "",
                    "close-on-content-click": false
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_VTextFieldFilled, _mergeProps({
                                modelValue: _ctx.bgColor,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.bgColor) = $event))
                              }, props, {
                                label: "Couleur de fond",
                                density: "compact",
                                readonly: "",
                                "hide-details": "",
                                disabled: _ctx.internalDisabled,
                                "data-cy": "AdvancedBoxEditor-couleurDeFond"
                              }), {
                                "prepend-inner": _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "d-flex align-self-center",
                                    style: _normalizeStyle(_ctx.colorIconStyle(_ctx.bgColor))
                                  }, null, 4)
                                ]),
                                _: 2
                              }, 1040, ["modelValue", "disabled"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_color_picker, {
                        modelValue: _ctx.bgColor,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.bgColor) = $event)),
                        "show-swatches": "",
                        mode: "hexa",
                        "hide-mode-switch": "",
                        swatches: _ctx.swatches,
                        disabled: _ctx.internalDisabled,
                        "data-cy": "AdvancedBoxEditor-couleur"
                      }, null, 8, ["modelValue", "swatches", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true),
          (_ctx.hasAttr(_ctx.styleObj, 'color') && _ctx.isUsed('color'))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 14,
                cols: _ctx.col,
                class: "px-2 py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_menu, {
                    "offset-y": "",
                    "close-on-content-click": false
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_VTextFieldFilled, _mergeProps({
                                modelValue: _ctx.textColor,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.textColor) = $event))
                              }, props, {
                                label: "Couleur du texte",
                                readonly: "",
                                "hide-details": "",
                                disabled: _ctx.internalDisabled,
                                density: "compact"
                              }), {
                                "prepend-inner": _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "d-flex align-self-center",
                                    style: _normalizeStyle(_ctx.colorIconStyle(_ctx.textColor))
                                  }, null, 4)
                                ]),
                                _: 2
                              }, 1040, ["modelValue", "disabled"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_color_picker, {
                        modelValue: _ctx.textColor,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.textColor) = $event)),
                        "show-swatches": "",
                        mode: "hexa",
                        "hide-mode-switch": "",
                        swatches: _ctx.textColorSwatches,
                        disabled: _ctx.internalDisabled
                      }, null, 8, ["modelValue", "swatches", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}